// Bootstrap Modules, jQuery and other Bootstrap dependencies provided by Webpack
import 'bootstrap'

// Import scripts
import './scripts/index.js'

// Images
import './images/logo-orkla-blue.svg'
import './images/logo-orkla-tagline-no.svg'
import './images/logo-orkla-tagline-no-white.svg'
import './images/logo-orkla-tagline-com.svg'
import './images/logo-orkla-tagline-com-white.svg'
import './images/logo-orkla-tagline-dk.svg'
import './images/logo-orkla-tagline-dk-white.svg'
import './images/logo-orkla-tagline-es.svg'
import './images/logo-orkla-tagline-se.svg'
import './images/logo-orkla-tagline-se-white.svg'
import './images/logo-orkla-tagline-fi.png'
import './images/logo-orkla-tagline-fi.svg'
import './images/logo-orkla-tagline-fi-white.png'
import './images/logo-orkla-tagline-fi-white.svg'
import './images/logo-without-payoff.svg'
import './images/logo-orkla-black.svg'
import './images/logo-orkla-gray.svg'
import './images/logo-orkla-blue.svg'
import './images/logo-orkla-denmark-footer.svg'
import './images/favicon.ico'
import './images/file-formats'
import './images/climate-img'

// Icons
import './images/icons'
import './images/social-medias'
import './images/step-number-icons'

// Product labels
import './images/product-labels'



//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/index.js
// module id = 3
// module chunks = 0